import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from 'antd';
import { ArrowDropDown } from '@material-ui/icons';
import { useLazyGetActiveCampaignsQuery } from 'core/worldCup/customerSupport/CustomerSupportService';
import { Campaign } from 'core/worldCup/customerSupport/types';

type CampaignSelectorProps = {
  onSelect: (campaignId: number) => void;
  selectedCampaignId: number | null;
  className?: string;
};

const CampaignSelector: React.FC<CampaignSelectorProps> = ({
  onSelect,
  selectedCampaignId,
  className,
}) => {
  const intl = useIntl();
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [getActiveCampaigns, { isFetching }] = useLazyGetActiveCampaignsQuery();

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      const res: any = await getActiveCampaigns().unwrap();
      const list = Array.isArray(res) ? res : res?.data ?? [];
      setCampaigns(list);
      setLoaded(true);

      if (list.length === 1) {
        onSelect(list[0].id);
      }
    } catch (e) {
      console.error('Error cargando campañas activas:', e);
      setLoaded(true);
    }
  };

  if (!loaded || campaigns.length <= 1) return null;

  return (
    <div className={`campaign_selector_wrapper ${className || ''}`}>
      <p className="campaign_selector_label">
        <FormattedMessage id="Campaign" />
      </p>
      <Select
        className="campaign_selector_select"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Select campaign' })}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
        value={selectedCampaignId || undefined}
        onChange={(value: number) => onSelect(value)}
        loading={isFetching}
        style={{ minWidth: 250 }}
      >
        {campaigns.map(c => (
          <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default CampaignSelector;
